import { useMediaQuery } from "react-responsive"
import React, { useEffect, useState } from "react"
import SupportDesktop from "./SupportDesktop"
import SupportMobile from "./SupportMobile"

const Support: React.FC = () => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    // Renderiza nulo até que o componente esteja montado para evitar problemas de hidratação
    if (!isMounted) {
        return null
    }

    return (
        <>
            { isDesktop ? <SupportDesktop /> : <SupportMobile /> }
        </>
    )
}

export default React.memo(Support)
